export const FILE_MANAGEMENT = {
  FETCH_FILE_MANAGEMENT_LIST: "FETCH_FILE_MANAGEMENT_LIST",
  FILE_MANAGEMENT_LISTS: "FILE_MANAGEMENT_LISTS",
  ADD_NEW_FOLDER: "ADD_NEW_FOLDER",
  FETCH_USER_DETAILS: "FETCH_USER_DETAILS",
  GET_ALL_FILES: "get_all_files",
  DELETE_FILE_MANAGEMENT_FOLDER: "DELETE_FILE_MANAGEMENT_FOLDER",
  GET_STORAGE_DATA: "GET_STORAGE_DATA",
  GET_STORAGE_DETAILS: "GET_STORAGE_DETAILS",
  DOWNLOAD_LIST: "DOWNLOAD_LIST",
  RESET_TO_ORIGINAL_STATE: "RESET_TO_ORIGINAL_STATE",
  UPLOAD_FILE_MANAGEMENT: "UPLOAD_FILE_MANAGEMENT",
  CHECK_ALL_CHECKBOX: "CHECK_ALL_CHECKBOX",
  CHECK_SINGLE_CHECKBOX: "CHECK_SINGLE_CHECKBOX",
  SORTING_ORDER: "SORTING_ORDER",
  SEARCH_VALUE: "SEARCH_VALUE",
  localSearch: "localSearch",
  UPDATE_FILE_NAME: "UPDATE_FILE_NAME",
  UPDATE_FOLDER_NAME: "UPDATE_FOLDER_NAME",
  LOCAL_FILTER: "LOCAL_FILTER",
  RETRY_UPLOAD: "RETRY_UPLOAD",
  DELETE_FILE: "DELETE_FILE",
  SEARCH_FILTER: "SEARCH_FILTER",
  SEARCH_FETCH_FILTER: "SEARCH_FETCH_FILTER",
  CLEAR_FILTER: "CLEAR_FILTER",
  ROW_KEY: "ROW_KEY",
  UPLOAD_PERCENTAGE: "UPLOAD_PERCENTAGE",
  CANCEL_UPLOAD: "CANCEL_UPLOAD",
  RESET: "RESET",
  DOWNLOAD_STARTED: "DOWNLOAD_STARTED",
};
